import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import { ProtectedRoute } from 'contexts/AuthContext';

import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const downSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;

  // set media wise responsive drawer: на xl+ раскрыт, ниже — узкий (иконки)
  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  const contentOffset = downSM ? 0 : drawerOpen ? DRAWER_WIDTH : MINI_DRAWER_WIDTH;

  return (
    <ProtectedRoute>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header />
        <Drawer />

        <Box component="main" sx={{ width: `calc(100% - ${contentOffset}px)`, flexGrow: 1, p: { xs: 2, sm: 3 } }}>
          <Toolbar sx={{ mt: 'inherit' }} />
          <Box
            sx={{
              ...{ px: { xs: 0, sm: 2 } },
              position: 'relative',
              minHeight: 'calc(100vh - 110px)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Breadcrumbs />
            <Outlet />
            <Footer />
          </Box>
        </Box>
      </Box>
    </ProtectedRoute>
  );
}
